// extracted by mini-css-extract-plugin
export var contact = "login-module--contact--FE9iW";
export var center = "login-module--center--GD80y";
export var formControl = "login-module--formControl--gXqui";
export var submit = "login-module--submit--VfLnX";